import React from "react";
import { FinalCTA } from "../shared-ui.jsx";

// Końcowe CTA — reuse istniejącego FinalCTA. Akceptuje chips jako stringi LUB obiekty {text}
// (Puck trzyma elementy tablicy jako obiekty) — normalizujemy do stringów.
const noop = () => {};

export function HomeFinalCta({ chips = [], navigate = noop }) {
  const list = chips.map((c) => (typeof c === "string" ? c : (c && c.text) || ""));
  return <FinalCTA navigate={navigate} chips={list} />;
}
